<template>
  <accessible-tabs>
    <ul role="tablist" class="filter-items">
      <slot
        :active="currentTab ? currentTab.id : undefined"
        :click="setTab"
        :move="goToTab"
      ></slot>
      <li
        class="filter-item"
        role="presentation"
        :class="[{ active: !currentTab }]"
        v-if="useAll"
      >
        <a
          id="exp-filter-all"
          href=""
          class="tab-group-button"
          role="tab"
          :aria-selected="!currentTab"
          @click.prevent="setTab()"
          @keydown.right.prevent="goToTab(constants.NEXT_TEXT)"
          @keydown.left.prevent="goToTab(constants.PREVIOUS_TEXT)"
        >
          {{ dictionary.all }}
        </a>
      </li>
      <li
        v-for="(tab, i) in tabs"
        :key="tab.id"
        class="filter-item"
        role="presentation"
        :class="[
          {
            active: currentTab && currentTab.id === tab.id,
            disabled: tab.isDisabled,
          },
        ]"
      >
        <a
          :id="'exp-filter-' + i"
          href=""
          class="tab-group-button"
          role="tab"
          :aria-selected="currentTab && currentTab.id === tab.id"
          :tabindex="tab.isDisabled ? '-1' : '0'"
          @click.prevent="setTab(tab)"
          @keydown.right.prevent="goToTab(constants.NEXT_TEXT)"
          @keydown.left.prevent="goToTab(constants.PREVIOUS_TEXT)"
        >
          {{ tab.label }}
        </a>
      </li>
    </ul>
  </accessible-tabs>
</template>

<script>
export default {
  name: "TabFilter",
  props: {
    query: {
      type: String,
      required: true,
    },
    queryableData: {
      type: String,
      required: false,
      default: "label",
    },
    tabs: {
      type: Array,
      required: true,
      validator(tabs) {
        return tabs.every((tab) =>
          ["id", "label"].every((item) => Object.keys(tab).includes(item))
        );
      },
    },
    dictionary: {
      type: Object,
      required: true,
      default: () => {
        return {
          all: "All",
        };
      },
    },
    updateQuery: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      },
    },
    useAll: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      currentTab: {},
      tabList: [],
      constants: {
        PREVIOUS_TEXT: "previous",
        NEXT_TEXT: "next",
        REGION_ALL: "all",
      },
    };
  },
  computed: {
    finalQuery() {
      return this.currentTab
        ? { [this.query]: this.currentTab[this.queryableData] }
        : undefined;
    },
  },
  watch: {
    finalQuery(val) {
      this.$emit("update:final-query", val);
    },
  },
  mounted() {
    this.getTabs();

    this.$nextTick(() => {
      if (this.$route && this.$route.query.tab) {
        this.setTab(
          this.tabs.find((tab) => tab.label === this.$route.query.tab)
        );
      } else {
        this.setTab(this.tabList[0]);
      }
    });
  },
  methods: {
    getTabs() {
      const defaultSlot =
        (this.$scopedSlots.default && this.$scopedSlots.default()) || [];
      defaultSlot.forEach((el) => {
        if (el.tag === "li") {
          const tabItem = {};
          tabItem.label = el.data.attrs["data-label"];
          tabItem.region = el.data.attrs["data-region"];
          tabItem.id = el.data.attrs["data-id"];

          this.tabList.push(tabItem);
        }
      });

      if (this.useAll)
        this.tabList.push({
          region: this.constants.REGION_ALL,
        });

      this.tabs.forEach((tab) => {
        this.tabList.push({
          ...tab,
          region: tab.label,
        });
      });
    },
    goToTab(direction) {
      let queryable = this.currentTab;
      const listSize = this.tabList.length;

      if (!queryable) queryable = { region: this.constants.REGION_ALL };

      const currentTabIndex = this.tabList.findIndex(
        (tab) => tab.region === queryable.region
      );

      console.log(currentTabIndex);
      console.log(queryable.region);

      if (direction === this.constants.NEXT_TEXT) {
        currentTabIndex >= listSize - 1
          ? this.setTab(this.tabList[0])
          : this.setTab(this.tabList[currentTabIndex + 1]);
      } else {
        currentTabIndex === 0
          ? this.setTab(this.tabList[listSize - 1])
          : this.setTab(this.tabList[currentTabIndex - 1]);
      }
    },
    setTab(tab) {
      if (tab && typeof tab === "string") {
        tab = this.tabList.filter((t) => t.id === tab)[0] || undefined;
      }

      if (!tab || tab.region === this.constants.REGION_ALL) tab = undefined;

      this.currentTab = tab;

      if (this.updateQuery && tab && this.$route.query.tab !== tab.label) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            tab: tab.label,
          },
        });
      } else if (!tab) {
        const newQuery = {
          ...this.$route.query,
        };

        delete newQuery.tab;

        this.$router.replace({ query: newQuery }).catch(() => {});
      }
    },
  },
};
</script>
